var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supplier-mgmt"},[_c('el-menu',{staticStyle:{"display":"none"},attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"}},_vm._l((_vm.componentsList),function(item){return _c('el-menu-item',{key:item.id,attrs:{"index":item.id},on:{"click":() => {
          _vm.setComponents(item);
        }}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1),_c('transition',{attrs:{"name":"router-slid","mode":"out-in"}},[_c('keep-alive',[_c(_vm.currentComponent,{tag:"component"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }